/**
 * Shared public environment config
 */
export const ENV_CONFIG = {
  firebase: {
    apiKey: 'AIzaSyA6Wx0pCOVlxyP3zWXGPHGqO9hTuwWTl30',
    authDomain: 'jp-bioinspekt.firebaseapp.com',
    projectId: 'jp-bioinspekt',
    storageBucket: 'jp-bioinspekt.appspot.com',
    messagingSenderId: '278358849621',
    appId: '1:278358849621:web:659f806fac2dfb6726fcdc',
    measurementId: 'G-MNQJGLQSQ3'
  }
};
